import { render, staticRenderFns } from "./carrousel.vue?vue&type=template&id=f907e338&scoped=true"
import script from "./carrousel.vue?vue&type=script&lang=js"
export * from "./carrousel.vue?vue&type=script&lang=js"
import style0 from "./carrousel.vue?vue&type=style&index=0&id=f907e338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907e338",
  null
  
)

export default component.exports